
<div class="lm-border pa-2 pt-3 pb-3 v-flex" style="position: relative">
    <p-audit-modification
        style="    position: absolute;
right: -78px;
transform: rotate(90deg);
font-size: 11px;
top: 85px;text-align: left; width: 175px;height: 20px;color: grey"
        :entry = "entry"
    />
    <div class="catalogue-frequence black--text"  v-if="isAudit">
        {{ isMeasure ? frequence.name : '' }}
    </div>

    <div style="display: block; width: calc(100% - 30px)" class="pr-0" :class="isAudit ? '' : 'ml-3'">

        <div class="v-flex" style="">
            <div class="catalogue-id">
                {{ entry.catalogue.id }}
            </div>

            <p-audit-rating
                v-if        = "edit"
                v-model     = "rating"
                :show-no    = "!isCyberSecurity"
                :inadequate = "entry.catalogue.inadequate && isAudit"
                class       = "ml-2"
            />
            <div
                v-if="!edit"
                class="catalogue-type ml-2"
                :class="typeColor"
            >
                {{ entry.type.name }}
            </div>

            <v-spacer />
            <div  class="v-flex" v-if="(isAudit || isEsg) && isPlaner">
                <div v-if="showBudgetData">
                    <c-toolbar-button
                        color    = "primary"
                        size     = "20"
                        :icon    = "edit ? 'mdi-content-save' : 'mdi-pencil'"
                        :tooltip = "edit ? 'Änderungen speichern' : 'Maßnahme bearbeiten'"
                        @click   = "onEdit"
                    />
                </div>

                <div class="ml-2" style="margin-top: 0">
                    <c-toolbar-button
                        v-if    = "edit"
                        color   = "primary"
                        size    = "28"
                        icon    = "mdi-close"
                        tooltip = "Bearbeitung ohne speichern beenden"
                        @click  = "onCancel"
                    />
                </div>
            </div>
        </div>

        <v-divider class="mt-2 mb-2" />
        <div v-html="entryTitle">
        </div>

        <v-divider
            v-if="isCyberSecurity"
            class="mt-3"
        />

        <div class="primary--text mt-3" style="font-size: 11px; width: 100px;" v-if="(entry.measure && !edit) || (isCyberSecurity && entry.type.id === 1) ">
            Maßnahme
        </div>
        <div
            v-if="isCyberSecurity && entry.type.id === 1"
        >
            <div v-html="entry.catalogue.measures[0].description">
            </div>
            <v-divider class="mt-3" />
        </div>

        <div
            v-if="(entry.type.id === 2 || entry.type.id === 4 || rating === 2 || rating === 4) && entry.measure"
            class="mt-0 mb-3 lm-border pa-3 pt-2"
            style="position: relative"
        >
            <div class="v-flex mb-2" style="justify-content: center" v-if="isAudit">
                <div>
                    <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                        Schwere
                    </div>
                    <div class="catalogue-weight lm-border"  v-if="isMeasure">
                        {{ weight.name }}
                    </div>
                </div>

                <div class="ml-2">
                    <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                        Risiko
                    </div>

                    <div class="catalogue-risk lm-border"  v-if="isMeasure">
                        {{ risk.name }}
                    </div>
                </div>

                <div class="ml-2">
                    <div class="primary--text" style="font-size: 9px; width: 100px; text-align: center">
                        Frist
                    </div>

                    <div class="catalogue-risk lm-border"  v-if="isMeasure">
                        {{ deadline ? deadline.name : '---' }}
                    </div>
                </div>
            </div>

            <div class="mb-2" v-if="!edit">
                {{ entryMeasure }}
            </div>

            <div v-if="edit"  class="mb-4 mt-4">
                <v-select
                    v-model            = "entry.measure"
                    label              = "Maßnahme"
                    :items             = "measures"
                    item-value         = "id"
                    item-text          = "description"
                    :return-object     = "true"
                    :rules             = "[ requiredRule ]"
                    :hide-details      = "(entry.measure && !!entry.measure.id)"
                    :key               = "refreshMeasures"
                >
                    <template v-slot:item="{ item }">
                        {{ measureText (item) }}
                    </template>
                    <template v-slot:selection="{ item }">
                        {{ measureText (item) }}
                    </template>
                </v-select>
            </div>


            <v-row dense v-if="showBudgetData && (isAudit || isEsg)">
                <v-col class = "col-6">
                    <v-switch
                        label     = "Maßnahme umgesetzt"
                        :ripple   = "false"
                        v-model   = "entry.done"
                        :readonly = "!edit"
                        hide-details
                    />
                </v-col>
                <v-col class = "col-6">
                    <c-inc-chooser
                        v-model = "entry.incidentId"
                        :unit   = "unit"
                        :edit   = "!entry.done"
                    />
                </v-col>
            </v-row>

            <v-row dense class="mt-2" v-if="showBudgetData && (isAudit || isEsg)">
                <v-col class="col-6">
                    <f-read-only-field
                        class  = "cost-rule"
                        :label = "$t('audit.costs.rule')"
                        :value = "costs (entry.measure)"
                        filled
                    />
                </v-col>
                <v-col class="col-6">
                    <f-currency-field-rw
                        v-model   = "entry.costs"
                        :label    = "$t('audit.costs.label')"
                        :readonly = "!edit"
                    />
                </v-col>
            </v-row>
        </div>
        <div>
            <f-read-only-field
                v-if   = "!edit"
                class  = "mt-2"
                label  = "Notiz"
                :value = "entry.notice"
                filled
                dense
            />
            <v-textarea
                v-if    = "edit"
                label   = "Notiz"
                class   = "mt-4"
                v-model = "entry.notice"
                rows    = "2"
                hide-details
                no-resize
            />
        </div>
    </div>

</div>
